import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ResourcesModal from './ResourcesModal';

const ResourcesBox = () => {
    const componentClass = 'resourcesBox';
    const [showModal, setShowModal] = useState(false);

    return <React.Fragment>
        <div className={componentClass}>
            <div className={`${componentClass}__title`}>
                <h1 className="isCursive">Wedding Details</h1>
                <span><i className="fa fa-heart" /></span>
            </div>
            <div className={`${componentClass}__body`}>
                <h4>Click the buttons below to learn more about specific wedding details:</h4>
                <div className="buttons-section">
                    <a className="btn btn-primary" href="https://withjoy.com/rockobolts-and-coripinkett/registry" target="_blank">Wedding Registry</a>
                    <button className="btn btn-outline-primary" onClick={() => setShowModal(true)}>Hotel Information</button>
                </div>
            </div>
        </div>
        <ResourcesModal show={showModal} onClose={() => setShowModal(false)} />
    </React.Fragment>;
};

ResourcesBox.propTypes = {
    text: PropTypes.string
};
export default ResourcesBox;
